module.exports = __webpack_public_path__ + "static/explan.016debf2.png";